export const EARTH_RADIUS = 6371009; // meters

export enum GeoJsonTypes {
  POLYGON = 'Polygon',
  MULTI_POLYGON = 'MultiPolygon',
  GEOMETRY_COLLECTION = 'GeometryCollection',
  FEATURE_COLLECTION = 'FeatureCollection',
  FEATURE = 'Feature',
}

export enum KmlTags {
  PLACEMARK = 'Placemark',
  NAME = 'name',
  POLYGON = 'Polygon',
  MULTI_GEOMETRY = 'MultiGeometry',
  COORDINATES = 'coordinates',
}

export enum MimeTypes {
  XML = 'application/xml',
}

export enum ParsingErrors {
  PARSER_ERROR = 'parsererror',
}

export enum FileExtensions {
  GEOJSON = '.geojson',
  KML = '.kml',
}
